<template>
    <div class="h-full w-full">
        Construyendo la seccion de: Secuencias
    </div>
</template>

<script>
export default {

}
</script>

<style>

</style>